import QuotesManagement from "../pages/QuotesManagement";
import Dashboard from "../pages/Dashboard";
import Attributes from "../pages/Attributes";
import ChildAttributes from "../pages/ChildAttributes";
import Products from "../pages/Products";
import Projects from "../pages/Projects";
import Subscribers from "../pages/Subscriber";
import Users from "../pages/User";
import Services from "../pages/Services";
import Sliders from "../pages/Sliders";
import Counts from "../pages/Counts";
import Details from "../pages/Details";
import History from "../pages/History";
import Blogs from "../pages/Blogs";
import References from "../pages/References";
import Departments from "../pages/Departments";
import Quotes from "../pages/Quote";
import AddQuote from "../pages/AddQuote";
import Careers from "../pages/Careers";
import DepartmentContact from "../pages/DepartmentContact";
import ProductDetails from "../pages/ProductDetails";
import ServiceDetails from "../pages/ServiceDetails";
import SlidersDetails from "../pages/SlidersDetails";
import BlogDetails from "../pages/BlogDetails";
import ReferenceDetails from "../pages/ReferenceDetails";
import DepartmentDetails from "../pages/DepartmentDetails";
import ProjectDetails from "../pages/ProjectDetails";
import adminDetails from "../pages/adminDetails";
import DepartmentContactDetails from "../pages/DepartmentContactDetails";
import QuoteDetails from "../pages/QuoteDetails";
import QuoteManagementDetails from "../pages/QuoteManagementDetails";
import QuoteManagementUpdate from "../pages/QuoteManagementUpdate";
import CareerDetails from "../pages/CareerDetails";
import Category from "../pages/Category";
import ChildCategory from "../pages/ChildCategory";
import Staff from "../pages/Staff";
import Customers from "../pages/Customers";
import CustomerOrder from "../pages/CustomerOrder";
import Orders from "../pages/Orders";
import OrderInvoice from "../pages/OrderInvoice";
import Coupons from "../pages/Coupons";
import Page404 from "../pages/404";
import ComingSoon from "../pages/ComingSoon";
import EditProfile from "../pages/EditProfile";
import Languages from "../pages/Languages";
import Currencies from "../pages/Currencies";
import Setting from "../pages/Setting";

const routes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/subscribers",
    component: Subscribers,
  },
  {
    path: "/users",
    component: Users,
  },
  {
    path: "/history",
    component: History,
  },
  {
    path: "/careers",
    component: Careers,
  },
  {
    path: "/sliders",
    component: Sliders,
  },
  {
    path: "/counts",
    component: Counts,
  },
  {
    path: "/details",
    component: Details,
  },
  {
    path: "/quotes",
    component: Quotes,
  },
  {
    path: "/add-quote",
    component: AddQuote,
  },
  {
    path: "/quotes-management",
    component: QuotesManagement,
  },
  {
    path: "/references",
    component: References,
  },
  {
    path: "/departments",
    component: Departments,
  },
  {
    path: "/contacts",
    component: DepartmentContact,
  },
  {
    path: "/projects",
    component: Projects,
  },
  {
    path: "/blogs",
    component: Blogs,
  },
  {
    path: "/services",
    component: Services,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/attributes",
    component: Attributes,
  },
  {
    path: "/attributes/:id",
    component: ChildAttributes,
  },
  {
    path: "/product/:id",
    component: ProductDetails,
  },
  {
    path: "/service/:id",
    component: ServiceDetails,
  },
  {
    path: "/career/:id",
    component: CareerDetails,
  },
  {
    path: "/reference/:id",
    component: ReferenceDetails,
  },
  {
    path: "/slider/:id",
    component: SlidersDetails,
  },
  {
    path: "/contact/:id",
    component: DepartmentContactDetails,
  },
  {
    path: "/contacts/:iddep",
    component: DepartmentContact,
  },
  {
    path: "/quote/:id",
    component: QuoteDetails,
  },
  {
    path: "/quotes-management/:id",
    component: QuoteManagementDetails,
  },
  {
    path: "/quotes-management/update/:id",
    component: QuoteManagementUpdate,
  },
  {
    path: "/department/:id",
    component: DepartmentDetails,
  },
  {
    path: "/blog/:id",
    component: BlogDetails,
  },
  {
    path: "/project/:id",
    component: ProjectDetails,
  },
  {
    path: "/admin/:id/previleges",
    component: adminDetails,
  },
  {
    path: "/categories",
    component: Category,
  },
  {
    path: "/languages",
    component: Languages,
  },
  {
    path: "/currencies",
    component: Currencies,
  },
  {
    path: "/categories/:id",
    component: ChildCategory,
  },
  {
    path: "/customers",
    component: Customers,
  },
  {
    path: "/customer-order/:id",
    component: CustomerOrder,
  },
  {
    path: "/our-staff",
    component: Staff,
  },
  {
    path: "/orders",
    component: Orders,
  },
  {
    path: "/order/:id",
    component: OrderInvoice,
  },
  {
    path: "/coupons",
    component: Coupons,
  },
  { path: "/settings", component: Setting },
  {
    path: "/404",
    component: Page404,
  },
  {
    path: "/coming-soon",
    component: ComingSoon,
  },
  {
    path: "/edit-profile",
    component: EditProfile,
  },
];

export default routes;
